import { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";

const TARGET = new Date("2027-01-01T00:00:00Z").getTime();

function pad(n) {
  return String(Math.max(0, n)).padStart(2, "0");
}

export default function Countdown() {
  const { t } = useLanguage();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, TARGET - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  const cells = [
    [days, t("countdown.days")],
    [pad(hours), t("countdown.hours")],
    [pad(minutes), t("countdown.minutes")],
    [pad(seconds), t("countdown.seconds")],
  ];

  return (
    <div data-testid="countdown-timer" className="inline-flex border border-gold/40">
      {cells.map(([val, label], i) => (
        <div key={label} className={`px-6 md:px-10 py-6 text-center ${i > 0 ? "border-l border-gold/40" : ""}`}>
          <div className="font-mono text-3xl md:text-5xl font-light text-golddark tabular-nums">{val}</div>
          <div className="mt-2 text-[10px] tracking-[0.3em] text-muted-foreground">{label}</div>
        </div>
      ))}
    </div>
  );
}
